module.exports = __webpack_public_path__ + "static/media/a-0.a46f4a80.png";